<template>
  <div>
    <v-btn @click="addScaleFeeItem" small>
      <v-icon>add</v-icon>item
    </v-btn>
    <table border="1">
      <tr>
        <th>Threshold</th>
        <th>Fee</th>
        <th>Scale</th>
        <th />
      </tr>
      <tr v-for="scaleFeeItem in scaleFeeItems" :key="scaleFeeItem.id">
        <td>
          <input
            type="number"
            v-model.number="scaleFeeItem.threshold"
            @input="updateScaleFeeDebounce(scaleFeeItem)"
            outline
          />
        </td>
        <td>
          <input
            type="number"
            v-model.number="scaleFeeItem.fee"
            @input="updateScaleFeeDebounce(scaleFeeItem)"
            outline
          />
        </td>
        <td>
          <input
            type="checkbox"
            v-model="scaleFeeItem.scale"
            @change="updateScaleFee(scaleFeeItem)"
          />
        </td>
        <td>
          <v-btn @click="removeScaleFeeItem(scaleFeeItem)" color="error" small>
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </table>
    <v-snackbar v-model="snackbar" :multi-line="true" :timeout="3000" :top="true">
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ScaleFeeEdit",
  props: ["id"],
  data() {
    return {
      scaleFeeItems: [],
      timerId: null,
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    fetchScaleItems() {
      nbmlaw
        .get(`/cors/admin/sales/scaleFees/${this.id}/scaleFeeItems`)
        .then(response => {
          // console.log(response.data);
          this.scaleFeeItems = response.data;
        })
        .catch(() => {});
    },
    updateScaleFeeDebounce(scaleFeeItem) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.updateScaleFee(scaleFeeItem);
      }, 750);
    },
    updateScaleFee(scaleFeeItem) {
      nbmlaw
        .put(`/cors/admin/sales/scaleFeeItems/${scaleFeeItem.id}`, scaleFeeItem)
        .then(() => {
          // console.log(response.data);
          this.snackbar = true;
          this.snackbarText = `Scale fee item ${scaleFeeItem.id} has been updated`;
          this.fetchScaleItems();
        })
        .catch(() => {});
    },
    removeScaleFeeItem(scaleFeeItem) {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(`/cors/admin/sales/scaleFeeItems/${scaleFeeItem.id}`)
          .then(() => {
            // console.log(response.data);
            this.fetchScaleItems();
          })
          .catch(() => {});
      }
    },
    addScaleFeeItem() {
      nbmlaw
        .post(`/cors/admin/sales/scaleFees/${this.id}/scaleFeeItems`, null)
        .then(() => {
          // console.log(response.data);
          this.fetchScaleItems();
        })
        .catch(() => {});
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.fetchScaleItems();
      }
    }
  }
};
</script>